/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ETextSearchType } from './ETextSearchType';
import {
    ETextSearchTypeFromJSON,
    ETextSearchTypeFromJSONTyped,
    ETextSearchTypeToJSON,
} from './ETextSearchType';

/**
 * 
 * @export
 * @interface ETextSearchTypeStringCombinableCriteria
 */
export interface ETextSearchTypeStringCombinableCriteria {
    /**
     * 
     * @type {ETextSearchType}
     * @memberof ETextSearchTypeStringCombinableCriteria
     */
    searchMode?: ETextSearchType;
    /**
     * 
     * @type {string}
     * @memberof ETextSearchTypeStringCombinableCriteria
     */
    value?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ETextSearchTypeStringCombinableCriteria
     */
    secondaryValue?: string | null;
}

/**
 * Check if a given object implements the ETextSearchTypeStringCombinableCriteria interface.
 */
export function instanceOfETextSearchTypeStringCombinableCriteria(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ETextSearchTypeStringCombinableCriteriaFromJSON(json: any): ETextSearchTypeStringCombinableCriteria {
    return ETextSearchTypeStringCombinableCriteriaFromJSONTyped(json, false);
}

export function ETextSearchTypeStringCombinableCriteriaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ETextSearchTypeStringCombinableCriteria {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'searchMode': !exists(json, 'searchMode') ? undefined : ETextSearchTypeFromJSON(json['searchMode']),
        'value': !exists(json, 'value') ? undefined : json['value'],
        'secondaryValue': !exists(json, 'secondaryValue') ? undefined : json['secondaryValue'],
    };
}

export function ETextSearchTypeStringCombinableCriteriaToJSON(value?: ETextSearchTypeStringCombinableCriteria | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'searchMode': ETextSearchTypeToJSON(value.searchMode),
        'value': value.value,
        'secondaryValue': value.secondaryValue,
    };
}

